import { AtsCompany, NRClientType } from "@/lib/model/NRXQ/nr";
import Candidate, { ExamInfo } from "@/lib/model/exam/candidate";
import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import _ from "lodash-es";

export class NRWork extends Model {
  id = 0;
  companyName = "";
  jobPositionName = "";
  startDate = "";
  stopDate = "";
  description = "";
  salaryMin = "";
  salaryMax = "";
}

export class NRProjectWork extends Model {
  salary = "";
  companyName = "";
  salaryBasic = "";
  salaryExtra = "";
  workOut = "";
}

export class NRProjectCase extends Model {
  id = 0;
  name = "";
  douyinId = "";
  type = [""];
  saleType = [""];
  duration = [""];
  screenshotUrl = "";
  screenshotUrlList: any[] = []; //截屏列表-前端用  由screenshotUr分隔 ^&*&^而来
  thirdUrl = "";
  videoUrlList = "";
  outVideoUrl = "";
  isSale = "";
  maxGmvMonth = "";
  maxGmv = "";
  isStart = "";
}

export class NRProjectShortVideoCase extends Model {
  id = 0;
  type = [""];
  saleType = [""];
  publishData = "";
  videoUrl = "";
  outVideoUrl = "";
  playNumber = "";
  likeNumber = "";
  commentNumber = "";
  shareNumber = "";
  duration = "";
  finishPercent = "";
  salesVolume = "";
}

export class NRProject extends Model {
  lastWork: NRProjectWork = new NRProjectWork();
  expWork: NRProjectWork = new NRProjectWork();
  caseList: NRProjectCase[] = [new NRProjectCase()];
  shortVideoList: NRProjectShortVideoCase[] = [new NRProjectShortVideoCase()];
}

export class NRAttachment extends Model {
  fileId = 0;
  fileType = "";
  fileName = "";
  fileUrl = "";
}

export class NREducation extends Model {
  id = 0;
  universityName = "";
  majorName = "";
  educationLevel = "";
  startDate = "";
  stopDate = "";
}

export class NRCandidate extends Model {
  positionType: number | null = null;
  atsCvId = 0;
  atsCvOutId = "";
  position = "";
  name = "";
  gender = "";
  age = "";
  educationHigh = "";
  city = "";
  phone = "";
  email = "";
  connectCode = "";
  cvEducation: NREducation[] = [new NREducation()];
  cvWork: NRWork[] = [new NRWork()];
  candidate: Candidate = new Candidate();
  exam: ExamInfo = new ExamInfo();
  canUpdateNrProject = 1;
  canUpdateNrAttachment = 1;
  afterUpdateNrProject = 0;
  atsCompanyId: any = null;
  atsUserToken: string | null = null;
  nrProject: NRProject = new NRProject();
  nrAttachmentList: NRAttachment[] = [new NRAttachment()];
  ossPrefix = "";
  resumeFileUrl = "";
  resumeFileName = "";
  isNr = 0;
  cvStatus = 0;
  // recommendStatus = "";
  recommendStatus = 0;
  recommendMessage = "";

  candidateConnectUrl = "";
  candidateReportUrl = "";

  createdTime = "";
  atsCompany = new AtsCompany();

  static RECOMMAND_STATUS = {
    UNSET: 0,
    RECOMMEND: 10,
    NOT_RECOMMEND: 20
  };

  assign(data: any) {
    const res = super.assign(data);
    if (!res.atsCompanyId) res.atsCompanyId = null;
    if (!res.positionType) res.positionType = null;
    //截屏url string转array
    if (res.nrProject.caseList.length) {
      res.nrProject.caseList.forEach((d: NRProjectCase) => {
        d.screenshotUrlList = d.screenshotUrl
          ? d.screenshotUrl.split("^&*&^")
          : [];
      });
    }
    return res;
  }

  static parse(
    fileUrl: string,
    fileName: string,
    type: NRClientType = NRClientType.NRClientTypeHR
  ) {
    let url = "";
    const param: any = {
      resumeFileUrl: fileUrl,
      resumeFileName: fileName
    };
    switch (type) {
      case NRClientType.NRClientTypeAdmin:
        url = "/aiExam/atsAdmin/resumeParse";
        break;
      case NRClientType.NRClientTypeHR:
        param.atsUserToken = localStorage.getItem("nrToken");
        url = "/aiExam/atsHr/resumeParse";
        break;
    }
    return request.post(url, param).then(resp => {
      console.log(resp);
      if (resp.data.code === 0) {
        return new NRCandidate().assign(resp.data.data);
      } else {
        throw new Error();
      }
    });
  }

  updateStatus(cvStatus: number) {
    const param: any = {
      atsCvId: this.atsCvId,
      cvStatus: cvStatus
    };
    return request.post("/aiExam/atsAdmin/cvUpdateStatus", param).then(resp => {
      console.log(resp);
      if (resp.data.code === 0) {
        return;
      } else {
        throw new Error();
      }
    });
  }

  setRecommend(recommendStatus: number, recommendMessage: string) {
    const param: any = {
      atsCvId: this.atsCvId,
      recommendStatus: recommendStatus,
      recommendMessage: recommendMessage
    };

    return request.post("/aiExam/atsAdmin/cvSetRecommend", param).then(resp => {
      console.log(resp);
      if (resp.data.code === 0) {
        return new NRCandidate().assign(resp.data.data);
      } else {
        throw new Error();
      }
    });
  }

  static get(id: any, type: NRClientType = NRClientType.NRClientTypeHR) {
    let url = "";
    const param: any = {
      atsCvId: id,
      atsCompanyId: ""
    };
    switch (type) {
      case NRClientType.NRClientTypeAdmin:
        param.atsCompanyId = localStorage.getItem("atsCompanyOutId");
        url = "/aiExam/atsAdmin/cvGet";
        break;
      case NRClientType.NRClientTypeHR:
        param.atsUserToken = localStorage.getItem("nrToken");
        url = "/aiExam/atsHr/cvGet";
        break;
      case NRClientType.NRClientTypeCandidate:
        param.atsCvOutId = id;
        url = "/aiExam/atsPublic/cvGet";
        break;
    }
    return request.post(url, param).then(resp => {
      console.log(resp);
      if (resp.data.code === 0) {
        const candidate = new NRCandidate();
        // 必须把null的值给一个初始值，否则无法判断类型assign
        candidate.positionType = 0;
        candidate.atsCompanyId = 0;
        candidate.assign(resp.data.data);
        console.log(candidate);
        if (candidate.cvWork.length == 1 && candidate.cvWork[0].id === 0)
          candidate.cvWork = [];
        if (
          candidate.cvEducation.length == 1 &&
          candidate.cvEducation[0].id === 0
        )
          candidate.cvEducation = [];
        return candidate;
      } else {
        throw new Error();
      }
    });
  }

  create(type: NRClientType = NRClientType.NRClientTypeHR) {
    let url = "";
    const param = _.cloneDeep(this);
    switch (type) {
      case NRClientType.NRClientTypeAdmin:
        url = "/aiExam/atsAdmin/cvCreate";
        break;
      case NRClientType.NRClientTypeHR:
        param.atsUserToken = localStorage.getItem("nrToken");
        url = "/aiExam/atsHr/cvCreate";
        break;
    }
    return request.post(url, param).then(resp => {
      console.log(resp);
      if (resp.data.code === 0) {
        return resp.data.data;
      } else {
        throw new Error();
      }
    });
  }

  edit(type: NRClientType = NRClientType.NRClientTypeHR) {
    let url = "";
    const param = _.cloneDeep(this);
    console.log(param);
    switch (type) {
      case NRClientType.NRClientTypeAdmin:
        url = "/aiExam/atsAdmin/cvUpdate";
        break;
      case NRClientType.NRClientTypeHR:
        param.atsUserToken = localStorage.getItem("nrToken");
        url = "/aiExam/atsHr/cvUpdate";
        break;
    }
    return request.post(url, param).then(resp => {
      console.log(resp);
      if (resp.data.code === 0) {
        return resp.data.data;
      } else {
        throw new Error();
      }
    });
  }

  static mcreate(
    type: NRClientType = NRClientType.NRClientTypeHR,
    cvList: any,
    param: any
  ) {
    let url = "";
    param["atsCvList"] = cvList;
    switch (type) {
      case NRClientType.NRClientTypeAdmin:
        url = "/aiExam/atsAdmin/cvMCreate";
        break;
      case NRClientType.NRClientTypeHR:
        param["atsUserToken"] = localStorage.getItem("nrToken");
        url = "/aiExam/atsHr/cvMCreate";
        break;
    }
    return request.post(url, param).then(resp => {
      console.log(resp);
      if (resp.data.code === 0) {
        return resp.data.data;
      } else {
        throw new Error();
      }
    });
  }
}

// 牛人推结构
export class NRRecommendPeople extends Model {
  atsCvId = 0;
  atsCvOutId = "";
  connectCode = "";
  showName = "";
  gender = "";
  positionType = 0;
  nrPublishTime = "";
  caseList: NRProjectCase[] = [new NRProjectCase()];
  shortVideoList: NRProjectShortVideoCase[] = [new NRProjectShortVideoCase()];
  candidateReportUrl = "";
  candidatePhotoUrl = "";

  get positionTypeName() {
    switch (this.positionType) {
      case 1:
        return "主播";
      case 2:
        return "编导";
      case 3:
        return "直播运营";
    }
  }

  //ats端牛人列表
  static list(p: any) {
    return request.post("aiExam/atsAdmin/nrList", p);
  }
  //客户端牛人列表
  static customList(p: any) {
    return request.post("aiExam/atsHr/nrList", p);
  }
}

// 大咖指路结构
export class NRDaka extends Model {
  atsDakaId = 0;
  atsDakaOutId = "";
  companyId = "";
  ossPrefix = "";
  name = "";
  companyName = "";
  positionName = "";
  photoUrl = "";
  description = "";
  isClose = 2;

  //面试列表
  static list(p: any, clientType = NRClientType.NRClientTypeAdmin) {
    if (clientType == NRClientType.NRClientTypeAdmin)
      return request.post("/aiExam/atsAdmin/dakaList", p);
    else {
      p.atsUserToken = localStorage.getItem("nrToken");
      return request.post("/aiExam/atsHr/dakaList", p);
    }
  }

  delete() {
    const param = _.cloneDeep(this);
    return request.post("/aiExam/atsAdmin/dakaCreate", param).then(resp => {
      console.log(resp);
      if (resp.data.code === 0) {
        return resp.data.data;
      } else {
        throw new Error();
      }
    });
  }

  create() {
    const param = _.cloneDeep(this);
    return request.post("/aiExam/atsAdmin/dakaCreate", param).then(resp => {
      console.log(resp);
      if (resp.data.code === 0) {
        return resp.data.data;
      } else {
        throw new Error();
      }
    });
  }

  edit() {
    const param = _.cloneDeep(this);
    return request.post("/aiExam/atsAdmin/dakaUpdate", param).then(resp => {
      console.log(resp);
      if (resp.data.code === 0) {
        return resp.data.data;
      } else {
        throw new Error();
      }
    });
  }
}
